import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { FaRegTrashCan } from 'react-icons/fa6';
import { CustomButton } from '../uiWrappers/button';
import { DeleteQuizModal } from './DeleteQuizModal';
import quizBgImage from '../../assets/icons/quizBgImage.svg';
import { QuizDataForAdmin } from '@mightybyte/business';
import { Badge } from '@/components/ui/badge.tsx';

interface QuizCardProps {
  quiz: QuizDataForAdmin;
}

export function QuizCard({ quiz }: QuizCardProps) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <DeleteQuizModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        quizId={quiz._id}
        quizNumber={quiz.number}
      />

      <div
        className="rounded-[20px] overflow-hidden shadow-sm hover:shadow-md transition-shadow border border-gray-200 flex flex-col"
        style={{
          width: '266px',
          height: '192px'
        }}
      >
        {/* Top Section - 120px ENTIRE section with colored background */}
        <div
          className="relative pl-4 pb-2 flex flex-col"
          style={{
            height: '120px',
            backgroundColor: quiz.isDraft ? 'var(--quiz-bg-draft)' : 'var(--quiz-bg-published)',
            ...(quiz.titleImage?.medium && {
              backgroundImage: `url(${quiz.titleImage.medium})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }),
          }}
        >
          {/* Overlay to reduce image opacity for all cards */}
          {quiz.titleImage?.medium && (
            <div className="absolute inset-0 bg-white/55" />
          )}

          {!quiz.isDraft &&
            <Badge className={'bg-brand absolute right-3 top-3'}
                   variant={'default'}
            >
                {'Published'}</Badge>
          }
          {/* Text content on left */}
          <div className={'relative flex flex-col justify-end h-full pt-4'}>
            <h3 className="font-bold text-gray-900 text-base">MODULE {quiz.number}</h3>
            <h3 className="font-semibold text-brand-dark text-base mb-1">{quiz?.title ?? '-'}</h3>
            <p className="text-sm font-semibold text-brand">{quiz?.questions?.length ?? 0} Questions</p>
          </div>

          {/* Icon in BOTTOM-RIGHT — hidden when a custom titleImage is set */}
          {!quiz.titleImage?.medium && (
            <img
              src={quizBgImage}
              alt="Quiz icon"
              className="absolute bottom-0 right-0 w-16 h-16 object-contain"
            />
          )}
        </div>

        {/* Bottom Section - 72px with white background */}
        <div className="bg-white px-3 py-3 flex items-center gap-3 justify-between" style={{ height: '72px' }}>
          <CustomButton
            variant="outline"
            className="flex-1"
            onClick={() => navigate({ to: '/admin/quizzes/$quizId', params: { quizId: quiz._id } })}
          >
            View/Edit
          </CustomButton>
            {quiz.isDraft ? <button
            onClick={() => setIsDeleteModalOpen(true)}
            className="w-[38px] h-[38px] text-red-500 bg-red-50 rounded-lg transition-colors justify-center items-center flex cursor-pointer"
            title="Delete quiz"
          >
            <FaRegTrashCan className="w-5 h-5" />
          </button> : null}
        </div>
      </div>
    </>
  );
}
